import { useCallback } from "react";

export const useCookie = () => {
  const getCookie = useCallback((name: string): string | null => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
  }, []);

  const setCookie = (name: string, value: string, daysToExpire = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value,
    )}; expires=${expires.toUTCString()}; path=/; domain=.aleaplay.com`;
  };

  const removeCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.aleaplay.com`;
  };

  return { getCookie, setCookie, removeCookie };
};
